export interface ShippingTransportLimit {
  maxWeight?: number;
  minWeight?: number;
  transportType?: 'package' | 'pallet' | 'none';
}

export type ShipmentType = 'parcel' | 'pallet';

/**
 * Tells whether the cart goes as a parcel or a pallet, `undefined` when no parcel nor pallet shipping takes it.
 *
 * Mirrors filtering of shippings by cart content in api `shipping.service.js` (action `list`), so it matches
 * the shippings offered at checkout. Keep them in sync.
 */
export function evaluateShipmentType(
  { hasPalletOnlyGoods, weight }: { hasPalletOnlyGoods: boolean; weight: number },
  transportLimits: ShippingTransportLimit[],
): ShipmentType | undefined {
  if (hasPalletOnlyGoods) return 'pallet';

  const cartWeight = Math.ceil(weight);
  const takesCart = (transportType: ShippingTransportLimit['transportType']) =>
    transportLimits.some(
      (l) =>
        l.transportType === transportType &&
        !(l.minWeight !== undefined && l.minWeight > cartWeight) &&
        !(l.maxWeight !== undefined && l.maxWeight < cartWeight),
    );

  if (takesCart('package')) return 'parcel';
  if (takesCart('pallet')) return 'pallet';
  return undefined;
}
